const Loader = ({ text, height, color }) => {
  return (
    <div
      className="flex items-center justify-center rounded-md"
      style={{
        height: height || "100%",
        minHeight: height ? undefined : "60vh",
        backgroundColor: color,
      }}
    >
      <div className="relative">
        <div
          className="w-12 h-12 border-[3px] border-[#00A7A6] border-t-transparent rounded-full animate-spin"
          role="status"
          aria-label="Chargement en cours"
        >
          <span className="sr-only">Chargement...</span>
        </div>
        <div className="absolute inset-0 w-12 h-12 border-[3px] border-[#00A7A6] border-opacity-20 rounded-full animate-ping" />
      </div>
      {text && <p className="ml-4">{text}</p>}
    </div>
  );
};

export default Loader;
